var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.04,
    height: 26.711,
    viewBox: "0 0 24.04 26.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.9,26.712l2-2,2,2,2-2,2,2,2-2,2,2,2-2,2,2,2-2,2,2,2-2,2,2V1.572A1.572,1.572,0,0,0,27.374,0H6.47A1.568,1.568,0,0,0,4.9,1.572Zm20.034-12.02H8.909V12.02H24.936Zm0,5.342H8.909V17.363H24.936ZM12.758,7.07h2.357V5.5H12.758V3.143H11.187V5.5H8.831V7.07h2.356V9.427h1.571Zm5.578,1.965V6.364h6.6V9.035Z",
    transform: "translate(-4.902 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionFileIcon);
export default __webpack_public_path__ + "static/media/prescription-file-icon.fefd8ab362f3a55abc9dff340a6f7292.svg";
export { ForwardRef as ReactComponent };